import { Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { DeliveryZone } from '@delivery/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { DeliveryActions } from '../store/actions';
import { StateWithDelivery } from '../store/delivery-state';
import { DeliveryZonesSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class DeliveryZonesFacade {
  constructor(
    private store: Store<StateWithDelivery>,
    private cityService: CityService,
  ) {}

  getDeliveryZones(): Observable<DeliveryZone[]> {
    return this.cityService.activeBaseStoreCode$.pipe(
      switchMap((id) => this.store.pipe(select(DeliveryZonesSelectors.getDeliveryZones(id)))),
    );
  }

  loadDeliveryZones(): void {
    this.cityService.activeBaseStoreCode$
      .pipe(
        take(1),
        map((id) => this.store.dispatch(new DeliveryActions.LoadDeliveryZones(id))),
      )
      .subscribe();
  }

  resetDeliveryZones(): void {
    this.store.dispatch(new DeliveryActions.ResetDeliveryZones());
  }
}
